export default "__VITE_ASSET__mylRz3Ul__"